import { Card } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Card)`
  border-radius: 8px;
  padding: 16px;
  @media (max-width: 576px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
